module.exports = __webpack_public_path__ + "img/auction.b66efe31.png";